const ENCODE_DEFAULT = {
    /**
     * Various array encoding formats.
     * - `seq` Where multiple items with the same name cluster as an array.
     * This will fail to encode an array of 1 element.  
     * - `php` Items with the same name followed by '[]' are clustered as an array.
     * - `json` Array is encoded as an json object.
     */
    arrayFormat: 'php'
};

const toJson = JSON.stringify;

export default {

    /**
     * Encodes an object into a HTTP query string.
     */
    Encode: function (obj, options) {

        // Default options
        options = Object.assign({}, ENCODE_DEFAULT, options);

        const params = new URLSearchParams();

        // 
        for (let key in obj) {
            let val = obj[key];

            // Some array
            if (Array.isArray(val)) {
                // Basic ( built-in ) array formatter
                switch (options.arrayFormat) {
                    case 'seq': val.forEach(x => params.append(key, toJson(x))); break;
                    case 'php': val.forEach(x => params.append(`${key}[]`, toJson(x))); break;
                    case 'json': params.append(key, toJson(val)); break;
                    // 
                    default: throw new Error("Invalid option, objectFormat must be 'json' or 'php'.");
                }
            }
            // Some Object
            else if (typeof val === 'object') {
                params.append(key, toJson(val));
            }
            // Some Value
            else {
                // null or undefined
                if (val === null || val === undefined) params.append(key, null);
                // valid value
                else params.append(key, val);
            }
        }

        return decodeURIComponent(params.toString());
    },

    /**
     * Converts a URI query string into object representation.
     */
    Decode: function (queryString, options) {

        // Default options
        options = Object.assign({}, ENCODE_DEFAULT, options);

        let data = {};
        const params = new URLSearchParams(queryString);
        for (let x of params) {

            var name = x[0];
            var val = x[1];

            // Array type
            if (name.endsWith('[]')) {
                let key = name.substr(0, name.length - 2);
                if (key in data) data[key].push(JSON.parse(val));
                else data[key] = [JSON.parse(val)];
            }
            // Object type
            else if (val[0] === '{' && val[val.length - 1] === '}') {
                data[name] = JSON.parse(val);
            }
            // Array type
            else if (options.arrayFormat === 'json' && (val[0] === '[' && val[val.length - 1] === ']')) {
                data[name] = JSON.parse(val);
            }
            // Basic type
            else {
                // We have an entry for this parameter already
                if (name in data) {
                    // Get existing value
                    var existing = data[name];
                    // If the existing value is an array, append to it.
                    if (Array.isArray(existing)) existing.push(JSON.parse(val));
                    // If it is not an array, then make it into one.
                    else data[name] = [existing, JSON.parse(val)];
                } else {
                    data[name] = JSON.parse(val);
                }
            }
        }
 
        return data;
    }
};